import {isSameMinute} from "date-fns";
import {format} from "date-fns-tz";
import {TZDate} from "react-day-picker";

export const generateTimesAndState = (
  interval: number,
  baseDate: Date,
  timezone: string,
  currentDate: Date,
  activeDate: Date | undefined,
  disabledAfter?: Date,
  disabledBefore?: Date
) => {
  const times: {
    hour: number;
    minute: number;
    isCurrent: boolean;
    isActive: boolean;
    label: string;
    disabled: boolean;
    localDate: Date;
  }[] = [];
  for (let mins = 0; mins < 24 * 60; mins += interval) {
    const hour = Math.floor(mins / 60);
    const minute = mins % 60;
    const localDate = new TZDate(baseDate, timezone);
    localDate.setHours(hour, minute, 0, 0);
    const isActive = activeDate ? isSameMinute(localDate, baseDate) : false;
    const isCurrent = isSameMinute(localDate, currentDate);
    const label = format(localDate, "h:mmaa", {timeZone: timezone});
    const disabled =
      (disabledAfter ? localDate > disabledAfter : false) || (disabledBefore ? localDate < disabledBefore : false);
    times.push({hour, minute, isCurrent, isActive, label, disabled, localDate});
  }
  return times;
};
